import CoverCardAudio from '../assets/img/cover-cards/audio.png';
import CoverCardDoc from '../assets/img/cover-cards/doc.png';
import CoverCardLink from '../assets/img/cover-cards/link.png';
import CoverCardMaterialWithoutContent from '../assets/img/cover-cards/material-without-content.png';
import CoverCardOutOfTime from '../assets/img/cover-cards/out-of-time.png';
import CoverCardQuizzDone from '../assets/img/cover-cards/quizz-done.png';
import CoverCardQuizz from '../assets/img/cover-cards/quizz.png';
import CoverCardTaskDone from '../assets/img/cover-cards/task-done.png';
import CoverCardTask from '../assets/img/cover-cards/task.png';
import CoverCardVideo from '../assets/img/cover-cards/video.png';
import CoverCardVideolesson from '../assets/img/cover-cards/videolesson.png';
import coverTestBlocked from '../assets/img/cover-test/cover-blocked.png';
import coverTestConfirmation from '../assets/img/cover-test/cover-confirmation.png';
import coverTestDefault from '../assets/img/cover-test/cover-default.png';
import coverTestStarted from '../assets/img/cover-test/cover-started.png';
import coverTestFormativeDueDate from '../assets/img/cover-test/img_task_duedate.png';
import coverTestFormative from '../assets/img/cover-test/img_task_start.png';
// import DefaultUser from '../assets/img/default/default-user.png';
import VideoContentPreview from '../assets/img/default/default-video-preview.jpeg';
import imageLayoutProgress from '../assets/img/image-layout-progress.png';
import LogoBig from '../assets/img/logo/logo-big.png';
import LogoIconS from '../assets/img/logo/logo-icon-s.png';
import NoBooks from '../assets/img/no-items/no-books.png';
// import NoCourses from '../assets/img/no-items/no-courses.png';
import NoModuleCoverAdd from '../assets/img/no-items/no-cover-add.png';
import NoItem from '../assets/img/no-items/no-item.png';
import NoMaterials from '../assets/img/no-items/no-materials.png';
import NoMembers from '../assets/img/no-items/no-members.png';
import NoModuleCover from '../assets/img/no-items/no-module-cover.png';
import NoUnitProgram from '../assets/img/no-items/no-unit-cover.png';
// import NoPosts from '../assets/img/no-items/no-posts.png';
// import NoQuestionsNew from '../assets/img/no-items/no-questions-new.png';
import NoQuestions from '../assets/img/no-items/no-questions.png';
// import NoTasks from '../assets/img/no-items/no-tasks.png';
import NoUsers from '../assets/img/no-items/no-users.png';
import Signup2 from '../assets/img/signup/img01.png';
import Signup3 from '../assets/img/signup/img02.png';
import Signup4 from '../assets/img/signup/img03.png';
import Signup5 from '../assets/img/signup/img06.png';
import Signup1 from '../assets/img/signup/ipad.png';

export default {
  getImage: (id) => {
    let componentImage;

    switch (id) {
      case 'logoBig':
        componentImage = LogoBig;
        break;

      case 'logoIconS':
        componentImage = LogoIconS;
        break;

      // case 'noCourses':
      //   componentImage = NoCourses;
      //   break;

      case 'noBooks':
        componentImage = NoBooks;
        break;

      case 'noMembers':
        componentImage = NoMembers;
        break;

      case 'noItem':
        componentImage = NoItem;
        break;

      // case 'noPosts':
      //   componentImage = NoPosts;
      //   break;

      case 'noQuestions':
        componentImage = NoQuestions;
        break;

      // case 'noQuestionsNew':
      //   componentImage = NoQuestionsNew;
      //   break;

      // case 'defaultUser':
      //   componentImage = DefaultUser;
      //   break;

      case 'videoContentPreview':
        componentImage = VideoContentPreview;
        break;

      case 'login':
        componentImage = Signup1;
        break;

      case 'signup1':
        componentImage = Signup1;
        break;

      case 'signup2':
        componentImage = Signup2;
        break;

      case 'signup3':
        componentImage = Signup3;
        break;

      case 'signup4':
        componentImage = Signup4;
        break;

      case 'signup5':
        componentImage = Signup5;
        break;

      // case 'noTasks':
      //   componentImage = NoTasks;
      //   break;

      case 'noUsers':
        componentImage = NoUsers;
        break;

      case 'noPictureProgram':
        componentImage = NoItem;
        break;

      case 'noModuleCover':
        componentImage = NoModuleCover;
        break;
      case 'noModuleCoverAdd':
        componentImage = NoModuleCoverAdd;
        break;

      case 'cover-test-started':
        componentImage = coverTestStarted;
        break;

      case 'cover-test-blocked':
        componentImage = coverTestBlocked;
        break;

      case 'cover-test-default':
        componentImage = coverTestDefault;
        break;

      case 'cover-test-confirmation':
        componentImage = coverTestConfirmation;
        break;

      case 'cover-test-formative':
        componentImage = coverTestFormative;
        break;

      case 'cover-test-formative-late':
        componentImage = coverTestFormativeDueDate;
        break;

      case 'image-layout-progress':
        componentImage = imageLayoutProgress;
        break;

      case 'cover-card-quizz':
        componentImage = CoverCardQuizz;
        break;

      case 'cover-card-task':
        componentImage = CoverCardTask;
        break;

      case 'cover-card-videolesson':
        componentImage = CoverCardVideolesson;
        break;

      case 'cover-card-quizz-done':
        componentImage = CoverCardQuizzDone;
        break;

      case 'cover-card-task-done':
        componentImage = CoverCardTaskDone;
        break;
      case 'cover-card-audio':
        componentImage = CoverCardAudio;
        break;
      case 'cover-card-doc':
        componentImage = CoverCardDoc;
        break;

      case 'cover-card-link':
        componentImage = CoverCardLink;
        break;

      case 'cover-card-material-without-content':
        componentImage = CoverCardMaterialWithoutContent;
        break;

      case 'cover-card-video':
        componentImage = CoverCardVideo;
        break;

      case 'cover-card-out-of-time':
        componentImage = CoverCardOutOfTime;
        break;

      case 'noMaterials':
        componentImage = NoMaterials;
        break;

      case 'noUnitProgram':
        componentImage = NoUnitProgram;
        break;

      default:
        componentImage = LogoBig;
        break;
    }

    return componentImage;
  },
};
